import React from "react";
import { useTheme } from "@material-ui/core/styles";
import { Button, Typography } from "@material-ui/core";
import { green } from "@material-ui/core/colors";
import CheckRoundedIcon from "@material-ui/icons/CheckRounded";

const CustomIcon = ({
  step,
  label,
  isActive = false,
  stepClick,
  completed,
}) => {
  const theme = useTheme();
  return (
    <Button style={{ position: "relative" }} onClick={() => stepClick()}>
      <div
        style={{
          width: 30,
          height: 30,
          backgroundColor: completed
            ? green[500]
            : isActive
            ? theme.palette.primary.main
            : theme.palette.grey[500],
          color: "#fff",
          borderRadius: "50%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          textAlign: "center",
          position: "absolute",
          left: 0,
        }}
      >
        {completed ? <CheckRoundedIcon /> : step}
      </div>
      <Typography
        variant="body1"
        color={isActive ? "primary" : "textSecondary"}
        align="left"
        style={{ marginLeft: theme.spacing(1) }}
      >
        {label}
      </Typography>
    </Button>
  );
};

export default CustomIcon;
